<script>
    // import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {copyObjectProperties, sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import ProductModal from "./ProductModal.svelte";
    import {PRODUCT_TYPE} from "../lib/constants";


    let list = null;
    let selectedId = 0;
    let editId = null;

    const pageHeaderControls = [
        {id: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ ΠΡΟΪΟΝΤΟΣ', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'ΠΡΟΪΟΝ', sortable: true, sort_way: 'ASC'},
        {key: 'type', title: 'ΕΙΔΟΣ', sortable: true, class: 'hidden-xs'},
        {key: 'price', title: 'ΤΙΜΗ', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
    ];


    const productTypes = [
        "Προϊόν",
        "Υπηρεσία"
    ];

    const load = () => {
        const onSuccess = result => {
            list = result;
        }

        const onFailure = err => {
        };

        R.handle(R.product.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onSearchChange = () => {
        load();
    }

    const onColumnSort = ({detail}) => {
        list = sort(list, detail.key, detail.sort_way === 'DESC');
    }

    const onCreate = () => {
        editId = 0;
    }

    const onEdit = (obj) => {
        selectedId = obj.id;
        editId = obj.id;
    }

    const closeEdit = (obj) => {
        if (obj) {
            let properties = ['id', 'name', 'price', 'is_active'];

            let item = list.find(x => x.id == obj.id);
            if (item) {
                copyObjectProperties(obj, item, properties);
                list = list;
            } else {
                list = [copyObjectProperties(obj, properties), ...list];
            }
        }
        editId = null;
    }

    const onDelete = (obj) => {
        Alert.delete("Διαγραφή προϊόντος", `Πρόκειται να διαγράψετε το προϊόν "${obj.name}".\nΘέλετε να συνεχίσετε;`, () => deleteItem(obj.id));
    }

    const deleteItem = id => {
        const onSuccess = result => {
            list = list.filter(x => x.id != result);
            Notifier.showMessage("Το προϊόν διαγράφτηκε");
        }

        const onFailure = err => {
            // if (err.code === 'not_allowed') {
            //     Alert.warning("Διαγραφή χρήστη", `Δεν επιτρέπεται να διαγράψετε αυτόν τον χρήστη!`);
            // }
        };

        R.handle(R.product.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<PageHeader title="Προϊόντα" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if list}
    <div class="panel">
        <div class="panel-body">
            {#if list.length}
                <table class="table table-list table-list-border">
                    <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                    <tbody>
                    {#each list as item}
                        <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                            <td>
                                <span class="is-link" class:not-active={ item.is_active == 0 } on:click="{ () => onEdit(item) }">
                                    { item.name }
                                </span>
                            </td>
                            <td class="text-gray hidden-xs">
                                { productTypes[item.type] }
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.price }
                            </td>
                            <td class="button-column pointer" title="διαγραφή προϊόντος" on:click="{ () => onDelete(item) }">
                                <AppIcon icon="trash" size="16"/>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {/if}
        </div>
    </div>
{/if}
{#if editId != null}
    <ProductModal productId="{ editId }" closeCallback="{ closeEdit }"/>
{/if}